var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"filters_content"},[_c('search-type'),_vm._v(" "),_c('search-title'),_vm._v(" "),_c('search-filter')],1),_vm._v(" "),_c('div',{staticClass:"col_results hidden-xs hidden-sm"},[_c('property-results')],1),_vm._v(" "),_c('map-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }